import '@babel/polyfill'
import 'mutationobserver-shim'
import 'bootstrap-icons/font/bootstrap-icons.css'
import Vue from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import './plugins/scanapi-vue'
import './plugins/chat-vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

Vue.config.productionTip = false
// SPA is served same-origin under /app/, so the default backend is the current origin (`/`).
// VUE_APP_ROOT_URL only stays around as the dev-server proxy target (read at build time).
Vue.prototype.$backendUrl = process.env.VUE_APP_ROOT_URL || '/'

import {FavoriteStorage} from '@/components/speaker/storage.js'
Vue.prototype.$storage = new FavoriteStorage(Vue.prototype.$api, Vue.prototype.$chat)
Vue.prototype.$storage.fetchUser()

import TalkList from '@/components/speaker/talk-list.vue';
import TalkDetail from '@/components/speaker/talk-detail.vue';
import TalkDetailPage from '@/components/speaker/talk-detail-page.vue';
import SpeakerList from '@/components/speaker/speaker-list.vue';
import SpeakerDetail from '@/components/speaker/speaker-detail.vue';
import SpeakerThumb from '@/components/speaker/speaker-thumb.vue';
import SpeakerCard from '@/components/speaker/speaker-card.vue';
import ChannelActivity from '@/components/channel/channel-activity.vue';

Vue.component('talk-list', TalkList)
Vue.component('talk-detail', TalkDetail)
Vue.component('talk-detail-page', TalkDetailPage)
Vue.component('speaker-list', SpeakerList)
Vue.component('speaker-detail', SpeakerDetail)
Vue.component('speaker-thumb', SpeakerThumb)
Vue.component('speaker-card', SpeakerCard)
Vue.component('channel-activity', ChannelActivity)

import ProductIndex from '@/components/exhibitor/product-index.vue';
import ExhibitorList from '@/components/exhibitor/exhibitor-list.vue';
Vue.component('product-index', ProductIndex)
Vue.component('exhibitor-list', ExhibitorList)

// Prevent infinite iframe nesting: zpcard creates iframes (IframeView) to
// embed bare Django pages. If such a page accidentally includes zpcard JS,
// the SPA must not re-initialize inside the iframe.
if (window.self !== window.top) {
  console.debug('zpcard: iframe detected, skipping SPA init')
} else {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}
